import { useEffect } from 'react'

import { Box, Button } from '@tino-frontend/coreui'
import { Markdown } from '@tino-frontend/markdown'
import { DownloadAppIcon, DownloadAppPictogram } from '@tino-frontend/icons'

import { Float } from 'layouts/container'

import { useRegisterToken } from 'modules/notification'
import { useTexts } from './register-token.texts'

export function RegisterTokenContainer() {
  const texts = useTexts()
  const { open, submit, listener, setOpen } = useRegisterToken()

  useEffect(() => {
    listener()
  }, [])

  function handleSubmit(accepted: boolean) {
    return () => {
      submit(accepted)
    }
  }

  function handleClose() {
    setOpen(false)
  }

  return (
    <Float maxWidth="xs" open={open} onChange={() => handleClose()}>
      <DownloadAppPictogram fontSize={4} />
      <Box pb={2} pt={4}>
        <Markdown
          paragraph={{
            variant: 'h5',
            fontWeight: 'normal',
          }}
        >
          {texts.title}
        </Markdown>
      </Box>
      <Markdown
        paragraph={{
          variant: 'body2',
        }}
      >
        {texts.description}
      </Markdown>

      <Box mt={4} display="flex" alignItems="center" gap={2}>
        <Button
          size="large"
          color="tertiary"
          variant="contained"
          data-testid="close"
          onClick={handleSubmit(false)}
          fullWidth
        >
          {texts.close}
        </Button>

        <Button
          size="large"
          color="primary"
          variant="contained"
          data-testid="submit"
          fullWidth
          startIcon={<DownloadAppIcon />}
          onClick={handleSubmit(true)}
        >
          {texts.submit}
        </Button>
      </Box>
    </Float>
  )
}
